module.exports = __webpack_public_path__ + "img/double-image-hero-nissan.0362dbdc.png";